import { InplaceDesignTokens } from '@primeuix/themes/types/inplace';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/inplace/index.ts
const ip = tDeep(componentCommon.inplace);

export const InplaceTelekomDT: InplaceDesignTokens = {
  root: {
    borderRadius: ip.border.radius,
    padding: `${ip.padding.y} ${ip.padding.x}`,
    focusRing: {
      width: ip.focus.ring.width,
      color: ip.focus.ring.color,
      offset: ip.focus.ring.offset,
    },
  },
  display: {
    hoverBackground: ip.display.hover.background,
    hoverColor: ip.display.hover.color,
  },
};
